export { default as VideoBanner } from './VideoBanner';
